import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AuthService from "../services/auth.service";
import Helpers from '../services/helpers';
import { Modal } from "react-bootstrap";
import Loader from './loader';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../app/store';
import { fetchStatements } from '../app/slice/txnSlice';
import moment from 'moment';
import After from '../assets/images/Vectorafter.png'
import Afteractive from '../assets/images/VectorActive.png'
import Excel from '../assets/images/excel.png'
import Jason from '../assets/images/jason.png'
import Moment from 'moment';
import { showToast } from '../app/slice/toastsSlice';
import Bitcoin from '../assets/images/bitcoinHead.png'

function Header() {
  const walletAmount = useSelector((state: RootState) => state.wallet.wallet);
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  let pageName = splitLocation[1];
  let pageTitle = pageName.replace(/[^a-zA-Z ]/g, " ");
  const Token = Helpers.getTokenData();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [wallet, setWallet] = useState<any | Number>(walletAmount);
  const [isPdfGenerating, setIsPdfGenerating] = useState<boolean>(false);
  const statementsData = useSelector((state: RootState) => state.statements);
  const [filterData, setFilterData] = useState<any>(statementsData?.filterData);
  const [currentDate, setCurrentDate] = useState<any>({
    from: '',
    to: ''
  });
  const [statementDate, setStatementDate] = useState<any>({
    from: '',
    to: ''
  });
  const [fileType, setFileType] = useState('');
  const [periodClass, setPeriodClass] = useState('');
  // State to track if the body is scrolled
  const [scrolled, setScrolled] = useState(false);

  // Effect to monitor the scroll event
  useEffect(() => {
    const handleScroll = () => {
      // If the window is scrolled more than 50px
      if (window.scrollY > 10) {
        setScrolled(true);

      } else {
        setScrolled(false); // Remove class if at the top
      }
    };

    // Attach the event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    setWallet(walletAmount);
  }, [walletAmount]);


  const handleDateClick = (e: any) => {
    const { name, value } = e.target;
    setCurrentDate((prev: any) => ({
      ...prev,
      [name]: value
    }));
  }

  const dispatch = useDispatch<AppDispatch>();
  const applyDateFilter = (type: any) => {
    setMessage('');
    if (type === 'apply') {
      if (currentDate?.from === '') {
        setMessage('from date required');
        return
      }
      if (currentDate?.to === '') {
        setMessage('to date required');
        return
      }
      if (currentDate?.from > currentDate?.to) {
        setMessage('from date can not be greater than to date');
        return
      }
      dispatch(fetchStatements({ type: filterData?.type, from: currentDate?.from, to: currentDate?.to, callBy: 'date' }));

    } else {
      setCurrentDate({ from: '', to: '' });
      dispatch(fetchStatements({ type: filterData?.type, from: '', to: '', callBy: 'date' }));
    }
  }

  useEffect(() => {
    if (statementsData?.filterData?.from == '' || statementsData?.filterData?.to == '') {
      setCurrentDate({ from: '', to: '' });
    }
    setFilterData(statementsData?.filterData);


  }, [statementsData?.filterData]);

  /********for auto closing date filter model */
  useEffect(() => {
    if (!statementsData?.isLoading) {
      setFilter(false);
    }

  }, [statementsData?.isLoading]);


  const [showcurrency, setCurrency] = useState(false);

  const handleClosecurrency = () => setCurrency(false);
  const handleShowcurrency = () => setCurrency(true);

  const [showfilter, setFilter] = useState(false);

  const handleCloseFilter = () => setFilter(false);
  const handleShowFilter = () => {
    setFilter(true);
    setDownload(false);
    setIsSearchOpen(false);
  }

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const toggleSearchBar = () => {
    setIsSearchOpen(!isSearchOpen);
    setFilter(false);
    setDownload(false);

  };

  useEffect(() => {
    if (isSearchOpen && inputRef.current) {
      inputRef.current.focus(); // Focus the input when the search bar is opened
    }
  }, [isSearchOpen]);

  const closeSearchBar = () => {
    setIsSearchOpen(false); // Close the search bar when the cross icon is clicked
  };

  const handleGeneratePdf = async () => {
    setScrolled(false);
    setIsPdfGenerating(true);
    let fileName = Date.now();
    try {
      const input = document.getElementById("reciept-container");

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });
      if (input) {
        html2canvas(input)
          .then((canvas) => {
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
            const imgX = (pdfWidth - imgWidth * ratio) / 2;
            const imgY = (pdfHeight - imgHeight * ratio) / 2;
            const imgData = canvas.toDataURL('image/jpeg');
            pdf.addImage(
              imgData,
              "jpeg",
              imgX,
              imgY,
              imgWidth * ratio,
              imgHeight * ratio
            );
            pdf.save(fileName + '.pdf');
            setTimeout(() => {
              setIsPdfGenerating(false);
            }, 500);
          });
      }
    } catch (error) {
      console.error("error generating pdf : ", error);
    }

  };

  const [showdownload, setDownload] = useState(false);

  const handleCloseDownload = () => {
    setDownload(false);
    setFileType('');
    setPeriodClass('');
    setLoading(false);
    setStatementDate({ from: '', to: '' });
  }

  const handleShowDownload = () => {
    setDownload(true);
    setIsSearchOpen(false);
    setFilter(false)
  }

  const handleStatementDateClick = (e: any) => {
    setPeriodClass('');
    const { name, value } = e.target;
    setStatementDate((prev: any) => ({
      ...prev,
      [name]: value
    }));
  }

  function handleClickPeriod(type: any) {
    let currentDate = Moment();
    setPeriodClass(type);
    let fromData: any = '';
    let endDate: any = '';

    if (type === 'today') {
      fromData = currentDate;
      endDate = currentDate;

    } else if (type === 'week') {
      fromData = currentDate.clone().startOf('isoWeek');
      endDate = currentDate.clone().endOf('isoWeek');

    } else if (type === 'month') {
      fromData = currentDate.clone().startOf('month');
      endDate = currentDate.clone().endOf('month');

    } else if (type === 'last_month') {
      fromData = currentDate.clone().subtract(1, 'month').startOf('month');
      endDate = currentDate.clone().subtract(1, 'month').endOf('month');

    } else if (type === 'year') {
      fromData = currentDate.clone().startOf('year').subtract(1, 'year');
      endDate = currentDate.clone().endOf('year').subtract(1, 'year');
    }

    setStatementDate((prev: any) => ({
      ...prev,
      from: fromData.format("YYYY-MM-DD"),
      to: endDate.format("YYYY-MM-DD")
    }));
  }

  function handleClickFileType(fileType: any) {
    setFileType(fileType)
  }

  const downloadStatement = (type: any) => {

    if (type === 'download') {
      if (statementDate?.from === '' || statementDate?.to === '') {
        let toast = {
          type: 'error',
          title: 'Error',
          message: 'Select valid period/ date range'
        }
        dispatch(showToast(toast));
        return;
      }

      if (fileType === '') {
        let toast = {
          type: 'error',
          title: 'Error',
          message: 'Select download file type'
        }
        dispatch(showToast(toast));
        return;
      }
      setLoading(true);
      AuthService.statementsDownload(statementDate)
        .then(
          (response) => {
            //console.log(response.data);
            if (response.status === 200) {
              if (response.data.length === 0) {
                let toast = {
                  type: 'info',
                  title: 'Error',
                  message: 'no statements found for download'
                }
                dispatch(showToast(toast));
                setLoading(false);
                return;
              }
              if (fileType === 'json') {
                let fileName = Date.now() + ".json";
                downloadFile({
                  data: JSON.stringify(response.data),
                  fileName: fileName,
                  fileType: 'text/json',
                })
              }

              if (fileType === 'csv') {
                let fileName = Date.now() + ".csv";
                let headers = ['Txn Id, Type, Title, Amount, Closing Balance, Date, Time'];

                let usersCsv = response.data.reduce((acc: any, user: any) => {
                  const { integrator_transaction_id, txn_type, bet_title, base_amount, closing_balance, created_at } = user;
                  acc.push([integrator_transaction_id, txn_type, bet_title, base_amount, closing_balance, created_at].join(','))
                  return acc
                }, []);

                downloadFile({
                  data: [...headers, ...usersCsv].join('\n'),
                  fileName: fileName,
                  fileType: 'text/csv',
                });
              }

            } else {
              setMessage(response?.message);
            }
          }
        ).catch((error) => {
          const message = error?.response?.data?.error_description;
          setMessage(message);
          if (error?.response?.data?.status === 401) {
            localStorage.removeItem("w_token");
            navigate('/login');
          }
        }).finally(() => {
          //setLoading(false);
        });

    } else {
      setFileType('');
      setPeriodClass('');
      setStatementDate({ from: '', to: '' });
    }
  }


  const downloadFile = ({ data, fileName, fileType }: any) => {
    const blob = new Blob([data], { type: fileType })
    const a = document.createElement('a')
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt);
    a.remove();
    setLoading(false);
  }


  return (
    <>
      <style>
        {`
       .modal.fade .modal-dialog {
          transition: transform .3s ease-out;
        transform: translate(0,100%) !important;
        }
        .modal.show .modal-dialog{
          transform: none !important;
        }
      `}
      </style>
      {isPdfGenerating && <Loader />}
      <nav className={`Navbar ${scrolled ? 'sticky' : 'stickyNone'}`}>
        <div className='titalBar'>
          <button onClick={() => navigate(-1)} className={`${pageTitle==='upi' || pageTitle==='qr' ? 'text-uppercase' : 'text-capitalize'}`}>
            <svg className='me-1' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z" fill="white" />
            </svg>
            {pageTitle}
          </button>
        </div>
        {pageName === 'match-list' &&
          <div className='d-flex'>
            <div className='Balance'>
              <h6 className='align-items-center d-flex'>
                <img src={Bitcoin} alt="" className='img-fluid curinceImg' />
                {wallet?.user_combined_wallet}
                <svg className='ms-2' xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                  <path d="M7.00063 5.1714L11.9504 0.22168L13.3646 1.63589L7.00063 7.9999L0.636719 1.63589L2.05093 0.22168L7.00063 5.1714Z" fill="white" />
                </svg>
              </h6>
              <div className='depWit depWitWeb'>
                <Link to="/deposit">
                  <button className='align-items-center d-flex'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
                      <path d="M8.07586 0.876484L6.24426 5.14008H4.41266C4.10866 5.14008 3.81226 5.16288 3.52346 5.22368L4.28346 3.39968L4.31386 3.33128L4.35946 3.20968C4.38226 3.15648 4.39746 3.11088 4.42026 3.07288C5.30186 1.02848 6.28986 0.390084 8.07586 0.876484ZM13.2363 5.34528L13.2211 5.33768C12.7651 5.20848 12.3015 5.14008 11.8303 5.14008H7.07266L8.78266 1.16528L8.80546 1.11208C8.91186 1.15008 9.02586 1.20328 9.13986 1.24128L10.8195 1.94808C11.7543 2.33568 12.4079 2.73848 12.8107 3.22488C12.8791 3.31608 12.9399 3.39968 13.0007 3.49848C13.0691 3.60488 13.1223 3.71128 13.1527 3.82528C13.1831 3.89368 13.2059 3.95448 13.2211 4.02288C13.3351 4.41048 13.3427 4.85128 13.2363 5.34528ZM12.9019 6.43208C12.5599 6.33328 12.2027 6.28008 11.8303 6.28008H4.41266C3.89586 6.28008 3.40946 6.37888 2.95346 6.57648C2.28626 6.86351 1.7177 7.33959 1.31793 7.94599C0.91817 8.55239 0.704696 9.26257 0.703857 9.98888V11.4709C0.703857 11.6533 0.719057 11.8281 0.741857 12.0105C0.909057 14.4273 2.20106 15.7193 4.61786 15.8789C4.79266 15.9017 4.96746 15.9169 5.15746 15.9169H11.0855C13.8975 15.9169 15.3795 14.5793 15.5239 11.9193C15.5315 11.7749 15.5391 11.6229 15.5391 11.4709V9.98888C15.538 9.19186 15.2812 8.41621 14.8065 7.77597C14.3318 7.13573 13.6642 6.66469 12.9019 6.43208ZM10.0215 11.5013H8.69146V12.8769C8.69146 13.1885 8.43306 13.4469 8.12146 13.4469C7.80986 13.4469 7.55146 13.1885 7.55146 12.8769V11.5013H6.22146C6.07028 11.5013 5.9253 11.4412 5.81841 11.3343C5.71151 11.2274 5.65146 11.0825 5.65146 10.9313C5.65146 10.7801 5.71151 10.6351 5.81841 10.5282C5.9253 10.4213 6.07028 10.3613 6.22146 10.3613H7.55146V9.07688C7.55146 8.76528 7.80986 8.50688 8.12146 8.50688C8.43306 8.50688 8.69146 8.76528 8.69146 9.07688V10.3613H10.0215C10.1726 10.3613 10.3176 10.4213 10.4245 10.5282C10.5314 10.6351 10.5915 10.7801 10.5915 10.9313C10.5915 11.0825 10.5314 11.2274 10.4245 11.3343C10.3176 11.4412 10.1726 11.5013 10.0215 11.5013Z" fill="white" />
                    </svg>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        }
        {pageName === 'transaction' &&
          <div className='d-flex'>
            <button
              className="filter Search_Bar_Btn"
              onClick={toggleSearchBar}
            >
              <svg
                className="m-0"
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  d="M9.66431 2.14468C13.8152 2.14468 17.1841 5.51354 17.1841 9.66446C17.1841 13.8154 13.8152 17.1842 9.66431 17.1842C5.51339 17.1842 2.14453 13.8154 2.14453 9.66446C2.14453 5.51354 5.51339 2.14468 9.66431 2.14468ZM9.66431 15.5132C12.8957 15.5132 15.513 12.8959 15.513 9.66446C15.513 6.43304 12.8957 3.81574 9.66431 3.81574C6.43289 3.81574 3.81559 6.43304 3.81559 9.66446C3.81559 12.8959 6.43289 15.5132 9.66431 15.5132ZM16.754 15.5726L19.1172 17.9358L17.9356 19.1174L15.5724 16.7542L16.754 15.5726Z"
                  fill="white"
                />
              </svg>
            </button>
            <button className='filter mx-2' onClick={handleShowDownload}>
              <svg className="m-0" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M10.2698 7.96052H14.1185L9.50011 12.5789L4.88168 7.96052H8.73037V2.57236H10.2698V7.96052ZM3.34221 14.8882H15.658V9.49999H17.1975V15.6579C17.1975 16.083 16.8529 16.4276 16.4277 16.4276H2.57247C2.14736 16.4276 1.80273 16.083 1.80273 15.6579V9.49999H3.34221V14.8882Z" fill="white" />
              </svg>
            </button>
            <button className='filter' onClick={handleShowFilter}>
              <svg className='m-0' xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                <path d="M6.00033 0.333344V2.00001H11.0003V0.333344H12.667V2.00001H16.0003C16.4606 2.00001 16.8337 2.37311 16.8337 2.83334V16.1667C16.8337 16.6269 16.4606 17 16.0003 17H1.00033C0.540092 17 0.166992 16.6269 0.166992 16.1667V2.83334C0.166992 2.37311 0.540092 2.00001 1.00033 2.00001H4.33366V0.333344H6.00033ZM15.167 8.66668H1.83366V15.3333H15.167V8.66668ZM4.33366 3.66668H1.83366V7.00001H15.167V3.66668H12.667V5.33334H11.0003V3.66668H6.00033V5.33334H4.33366V3.66668Z" fill="white" />
              </svg>
            </button>
            <div className={`Search_BarHead ${isSearchOpen ? "" : "d-none"}`}>
              <input type="text" placeholder="Search history" ref={inputRef} name="search_history" />
              <button className="close-btn" onClick={closeSearchBar}>
                Close
              </button>
            </div>
          </div>
        }
        {pageName === 'reciept' &&
          <button className='filter' onClick={handleGeneratePdf}>
            <svg className='m-0' width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.2698 7.96052H14.1185L9.50011 12.5789L4.88168 7.96052H8.73037V2.57236H10.2698V7.96052ZM3.34221 14.8882H15.658V9.49999H17.1975V15.6579C17.1975 16.083 16.8529 16.4276 16.4277 16.4276H2.57247C2.14736 16.4276 1.80273 16.083 1.80273 15.6579V9.49999H3.34221V14.8882Z" fill="white" />
            </svg>
          </button>
        }
      </nav>

      {/* statements date filters */}
      <Modal show={showfilter} onHide={handleCloseFilter} className='selectCurrency modal-slide-up selectPeriod' >
        <Modal.Body className='datePickerbtn' style={{ paddingBottom: '20px' }}>
          <div className='d-flex justify-content-between align-items-center border-b-cst pt-0'>
            <h2 className='text-white m-0'>Filters</h2>
            {(currentDate?.from !== '' || currentDate?.to !== '') &&
              <button className='filterCl' onClick={() => applyDateFilter('clear')}>Clear</button>
            }
          </div>
          <div>
            <h2 className='text-white mt-3'>Select Period</h2>
            <div className='d-flex align-items-center justify-content-between flex-wrap border-b-cst filterBtn' style={{ borderBottom: 0 }}>
              <div className='datePicker'>
                <input type="date" id="from" name="from" value={currentDate?.from} max={moment().format("YYYY-MM-DD")}
                  onChange={(e) => handleDateClick(e)} />
              </div>
              <p className='m-0 text-white px-2'>-</p>
              <div className='datePicker'>
                <input type="date" id="to" name="to" value={currentDate?.to} max={moment().format("YYYY-MM-DD")}
                  onChange={(e) => handleDateClick(e)} />
              </div>

            </div>
            {message && <p className='text-center invalid'>{message}</p>}
            <button className='btn btn-primary' onClick={() => applyDateFilter('apply')}>Apply</button>

            {/* <RangePicker/> */}
          </div>
        </Modal.Body>
      </Modal>

      {/* statements download filters */}
      <Modal show={showdownload} onHide={handleCloseDownload} className='selectCurrency modal-slide-up'>
        <Modal.Body className='datePickerbtn' style={{ paddingBottom: '20px' }}>
          <div className="col-12">
            <form className='depositAmount'>
              <div className='d-flex justify-content-between align-items-center border-b-cst pt-0'>
                <h2 className='text-white m-0'>Download Statement</h2>
                <button type='button' className='filterCl' onClick={() => downloadStatement('clear')}>Clear</button>
              </div>
              <div>
                <h2 className='text-white mt-3'>Select Period</h2>
                <div className='d-flex align-items-center flex-wrap border-b-cst filterBtn' style={{ borderBottom: 0 }}>
                  <button type='button' className={`${periodClass === 'today' && 'border'}`} onClick={() => handleClickPeriod('today')}>Today</button>
                  <button type='button' className={`${periodClass === 'week' && 'border'}`} onClick={() => handleClickPeriod('week')}>This Week</button>
                  <button type='button' className={`${periodClass === 'month' && 'border'}`} onClick={() => handleClickPeriod('month')}>This Month</button>
                  <button type='button' className={`${periodClass === 'last_month' && 'border'}`} onClick={() => handleClickPeriod('last_month')}>Previous Month</button>
                  <button type='button' className={`${periodClass === 'year' && 'border'}`} onClick={() => handleClickPeriod('year')}>Last Year</button>
                </div>
              </div>
              <div>
                <h2 className='text-white mt-3'>Date Range</h2>
                <div className='d-flex align-items-center justify-content-between flex-wrap border-b-cst filterBtn'>
                  <div className='datePicker'>
                    <input type="date" id="from" name="from" value={statementDate?.from} max={moment().format("YYYY-MM-DD")}
                      onChange={(e) => handleStatementDateClick(e)} />
                  </div>
                  <p className='m-0 text-white px-2'>-</p>
                  <div className='datePicker'>
                    <input type="date" id="to" name="to" value={statementDate?.to} max={moment().format("YYYY-MM-DD")}
                      onChange={(e) => handleStatementDateClick(e)} />
                  </div>

                </div>
              </div>
              <div className='paymentGetway mt-3'>
                <div className='d-flex align-items-center justify-content-between'>
                  <h6 className='text-white'>File Type</h6>
                </div>
                <ul className='bankList'>
                  <li className={fileType === 'csv' ? 'selected' : ''} // Add 'selected' class if this <li> is clicked
                  >
                    <div className='d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center justify-content-between'>
                        <img src={Excel} alt="Hdfc" className='img-fluid' />
                        <div>
                          <p>Excel (CSV)</p>
                        </div>
                      </div>
                      <img src={After} alt="After" className='img-fluid after' />
                      <img src={Afteractive} alt="After" className='img-fluid afterActive' />
                    </div>
                    <div className="form-check" onClick={() => handleClickFileType('csv')}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="csvRadioBtn"
                        id="csvRadioBtn"
                      />
                      <label className="form-check-label" htmlFor=''>
                        Default radio
                      </label>
                    </div>
                  </li>

                  <li className={fileType === 'json' ? 'selected' : ''} // Add 'selected' class if this <li> is clicked
                  >
                    <div className='d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center justify-content-between'>
                        <img src={Jason} alt="Hdfc" className='img-fluid' />
                        <div>
                          <p>JSON</p>
                        </div>
                      </div>
                      <img src={After} alt="After" className='img-fluid after' />
                      <img src={Afteractive} alt="After" className='img-fluid afterActive' />
                    </div>
                    <div className="form-check" onClick={() => handleClickFileType('json')}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="jsonRadioBtn"
                        id="jsonRadioBtn"
                      />
                      <label className="form-check-label" htmlFor=''>
                        Default radio
                      </label>
                    </div>
                  </li>
                </ul>

                <button type="button" className='btn btn-primary' onClick={!loading ? () => downloadStatement('download') : undefined}>
                  {loading ?
                    <>
                      <span className="spinner-border spinner-border-sm me-1" role="status"></span>Please wait...
                    </>
                    :
                    <>Download</>
                  }

                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default Header;